import React from 'react'
import "./Services.css";
// import PropTypes from "prop-types";
import { Banner, ServiceCard2 } from '../../Module_Exporter/Module_Exporter';
import {  services_page_data, } from '../../functions/DefaultValues';
import { generate_random } from '../../functions/functions';
import { Helmet } from 'react-helmet-async';

function Services(props) {











  return (
    <>
    <Helmet>    
    <title>CodeSperix-Services</title>
    </Helmet>
    <main id='services_page'  >
   <Banner className="ServiceBanner"  t1={services_page_data.main_heading.t1} text={services_page_data.main_heading_sub_headline} t2={services_page_data.main_heading.t2}  w={services_page_data.bar.w}  />
     <div className="services_container main_container">
{
  services_page_data.services.map((obj,i)=><ServiceCard2 aos={i%2===0?"fade-left":"fade-right"} id={obj.id+i} key={generate_random(6)+"id"} index={i} title={obj.title} detial={obj.detial} icon={obj.icon} />)
}
     
      

     </div>
    </main>
    </>
  )
}

export default Services